export default __webpack_public_path__ + "static/media/icon_visibility.e83e83cb.svg";